import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function Skip({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Path
        d="M7.03639 7.44528C6.83181 7.3089 6.56879 7.29619 6.35201 7.4122C6.13524 7.52821 5.99992 7.75412 5.99992 7.99998V16C5.99992 16.2458 6.13524 16.4718 6.35201 16.5878C6.56879 16.7038 6.83181 16.6911 7.03639 16.5547L10.6666 14.1345V12.5321L7.33325 14.7543V9.24566L10.6666 11.4679V9.86541L7.03639 7.44528Z"
        fill={iconColor}
      />
      <Path
        d="M12.352 16.5878C12.1352 16.4718 11.9999 16.2458 11.9999 16V7.99998C11.9999 7.75412 12.1352 7.52821 12.352 7.4122C12.5688 7.29619 12.8318 7.3089 13.0364 7.44528L19.0364 11.4453C19.2219 11.5689 19.3333 11.7771 19.3333 12C19.3333 12.2229 19.2219 12.431 19.0364 12.5547L13.0364 16.5547C12.8318 16.6911 12.5688 16.7038 12.352 16.5878ZM13.3333 14.7543L17.4647 12L13.3333 9.24566V14.7543Z"
        fill={iconColor}
      />
      <Path
        d="M11.9999 1.33331C6.10888 1.33331 1.33325 6.10894 1.33325 12C1.33325 17.891 6.10888 22.6666 11.9999 22.6666C17.891 22.6666 22.6666 17.891 22.6666 12C22.6666 6.10894 17.891 1.33331 11.9999 1.33331ZM2.66659 12C2.66659 6.84532 6.84526 2.66665 11.9999 2.66665C17.1546 2.66665 21.3333 6.84532 21.3333 12C21.3333 17.1546 17.1546 21.3333 11.9999 21.3333C6.84526 21.3333 2.66659 17.1546 2.66659 12Z"
        fill={iconColor}
      />
    </Svg>
  );
}
